(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["euphoria-home-page-aug"] && !Shopify.designMode) return;
  try {
    

  (function () {
    function initHeroMobileExpand(section) {
      var mobileQuery = window.matchMedia('(max-width: 767px)');
      var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      var collapsedVh = parseFloat(section.getAttribute('data-collapsed-vh')) || 60;
      var maxVh = parseFloat(section.getAttribute('data-max-vh')) || 100;
      var scrollPx = parseFloat(section.getAttribute('data-scroll-px')) || 300;

      var collapsedHeight = 0;
      var expandedHeight = 0;
      var ticking = false;

      function recalc() {
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        collapsedHeight = vh * (collapsedVh / 100);
        var fullNineSixteen = vw * (16 / 9);
        expandedHeight = Math.min(fullNineSixteen, vh * (maxVh / 100));
        if (expandedHeight < collapsedHeight) expandedHeight = collapsedHeight;
      }

      function apply() {
        if (!mobileQuery.matches) {
          section.style.removeProperty('--eh-mobile-hero-height');
          return;
        }
        if (reduceMotionQuery.matches) {
          section.style.setProperty('--eh-mobile-hero-height', expandedHeight + 'px');
          return;
        }
        var progress = window.scrollY / scrollPx;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;
        var height = collapsedHeight + (expandedHeight - collapsedHeight) * progress;
        section.style.setProperty('--eh-mobile-hero-height', height + 'px');
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          apply();
          ticking = false;
        });
      }

      function onResize() {
        recalc();
        apply();
      }

      recalc();
      apply();

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', onResize);
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(onResize);
      }
    }

    document.querySelectorAll('[data-eh-hero-mobile-expand]').forEach(initHeroMobileExpand);
  })();


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-eh-tabs]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('[data-eh-tab-btn]');
      var bodies = wrap.querySelectorAll('[data-eh-tab-body]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.getAttribute('data-eh-tab-btn');
          btns.forEach(function (b) { b.classList.remove('is-active'); });
          bodies.forEach(function (p) { p.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var target = wrap.querySelector('[data-eh-tab-body="' + idx + '"]');
          if (target) target.classList.add('is-active');
        });
      });
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-eh-ing-scrolly]').forEach(function (wrap) {
      var cards = wrap.querySelectorAll('[data-eh-ing-card]');
      var pins = wrap.querySelectorAll('[data-eh-ing-pin]');

      function reveal(idx) {
        var card = wrap.querySelector('[data-eh-ing-card="' + idx + '"]');
        var pin = wrap.querySelector('[data-eh-ing-pin="' + idx + '"]');
        if (card) card.classList.add('is-visible');
        if (pin) pin.classList.add('is-visible');
      }

      if (!('IntersectionObserver' in window)) {
        cards.forEach(function (c) { reveal(c.getAttribute('data-eh-ing-card')); });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target.getAttribute('data-eh-ing-card'));
          }
        });
      }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });

      cards.forEach(function (c) { observer.observe(c); });
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-eh-faq]').forEach(function (wrap) {
      wrap.querySelectorAll('[data-eh-faq-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.eh-faq__item');
          if (!item) return;
          item.classList.toggle('is-open');
        });
      });
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["euphoria-listicle-6-reasons"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', function () {
   document.querySelectorAll('[data-eup-carousel]').forEach(function (carousel) {
     var slides = carousel.querySelectorAll('.eup-hero__slide');
     if (slides.length <= 1) {
       var arrows = carousel.querySelectorAll('.eup-hero__arrow');
       arrows.forEach(function (a) { a.style.display = 'none'; });
       return;
     }
     var dotsWrap = carousel.querySelector('[data-eup-dots]');
     var current = 0;


     slides.forEach(function (_, i) {
       var dot = document.createElement('button');
       if (i === 0) dot.classList.add('is-active');
       dot.addEventListener('click', function () { goTo(i); });
       dotsWrap.appendChild(dot);
     });


     function goTo(index) {
       slides[current].classList.remove('is-active');
       dotsWrap.children[current].classList.remove('is-active');
       current = (index + slides.length) % slides.length;
       slides[current].classList.add('is-active');
       dotsWrap.children[current].classList.add('is-active');
     }


     var prevBtn = carousel.querySelector('[data-eup-prev]');
     var nextBtn = carousel.querySelector('[data-eup-next]');
     if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
     if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });


     var slidesWrap = carousel.querySelector('.eup-hero__slides');
     var touchStartX = 0;
     var touchEndX = 0;
     if (slidesWrap) {
       slidesWrap.addEventListener('touchstart', function (e) {
         touchStartX = e.changedTouches[0].screenX;
       }, { passive: true });
       slidesWrap.addEventListener('touchend', function (e) {
         touchEndX = e.changedTouches[0].screenX;
         var deltaX = touchEndX - touchStartX;
         if (Math.abs(deltaX) > 40) {
           if (deltaX < 0) { goTo(current + 1); } else { goTo(current - 1); }
         }
       }, { passive: true });
     }


     setInterval(function () { goTo(current + 1); }, 2500);
   });
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
